const hasOwnProperty = Object.prototype.hasOwnProperty

if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value(object: unknown, property: PropertyKey): boolean {
      return hasOwnProperty.call(object, property)
    },
    configurable: true,
    writable: true,
  })
}

// Safari < 15.4 and older WebViews lack Array.prototype.at, which esbuild does
// not polyfill for the safari14/chrome87 build target.
if (!Array.prototype.at) {
  const at = function at<T>(this: readonly T[], index: number): T | undefined {
    const length = this.length
    let normalized = Math.trunc(index) || 0
    if (normalized < 0) normalized += length
    if (normalized < 0 || normalized >= length) return undefined
    return this[normalized]
  }

  Object.defineProperty(Array.prototype, 'at', {
    value: at,
    configurable: true,
    writable: true,
    enumerable: false,
  })
}
